import React from 'react'
import { Box, Container, Typography } from '@mui/material'

type HeroProps = {
  title: string
  subtitle: string
}

const Hero: React.FC<HeroProps> = ({ title, subtitle }) => (
  <Box component="header" sx={{ bgcolor: 'primary.main', color: 'white', py: { xs: 2, md: 3 } }}>
    <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="subtitle1">{subtitle}</Typography>
    </Container>
  </Box>
)

export default Hero

